import { EntityModel } from '@/interfaces'
import {
  ALL_HEADER_SLIDER_BLOCKS_QUERY,
  CREATE_HEADER_SLIDER_BLOCK_MUTATION,
  DELETE_HEADER_SLIDER_BLOCK_MUTATION,
  FORCE_DELETE_HEADER_SLIDER_BLOCK_MUTATION,
  SINGLE_HEADER_SLIDER_BLOCK_QUERY,
  UPDATE_HEADER_SLIDER_BLOCK_MUTATION,
} from './graphql'
import travelEntity from '@/entities/travel/entity'
import cmsHeaderSliderBlockSlideEntity from '@/entities/cmsHeaderSliderBlockSlide/entity'

const cmsHeaderSliderBlockModel: EntityModel = {
  name: 'headerSliderBlock',
  namePlural: 'headerSliderBlocks',
  uniqueName: 'cmsHeaderSliderBlock',
  uniqueNamePlural: 'cmsHeaderSliderBlocks',
  path: 'cms/blocks/header_slider_block',
  baseUrl: '/cms/blocks/header_slider_blocks',
  translationPrefix: 'entities:cmsHeaderSliderBlock.',
  getDisplayName: (values: any) => {
    return 'Header Slider Block'
  },
  gql: {
    getAll: ALL_HEADER_SLIDER_BLOCKS_QUERY,
    getSingle: SINGLE_HEADER_SLIDER_BLOCK_QUERY,
    create: CREATE_HEADER_SLIDER_BLOCK_MUTATION,
    update: UPDATE_HEADER_SLIDER_BLOCK_MUTATION,
    delete: DELETE_HEADER_SLIDER_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_HEADER_SLIDER_BLOCK_MUTATION,
  },
  attributes: {
    travels: {
      name: 'travels',
      label: 'entities:cmsHeaderSliderBlock.attributes.travels.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return travelEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    slides: {
      name: 'slides',
      label: 'entities:cmsHeaderSliderBlock.attributes.slides.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return cmsHeaderSliderBlockSlideEntity
      },
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsHeaderSliderBlockModel
